<template>
    <button :disabled="disabled"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-uknar-primary-dark shadow-sm text-sm font-medium rounded-md text-white bg-uknar-primary hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'SaveButton',
    props: {
        text: {
            type: String,
            default: 'Save'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
